import React from 'react';
import { Link } from "react-router-dom";

class Menu extends React.Component {
  render() {
    return (
        <aside id="sidebar-left" className="sidebar-left">
            <div className="sidebar-header">
                <div className="sidebar-title">
                    Navigation
                </div>
                <div className="sidebar-toggle hidden-xs sidebar-toggle-fix" data-toggle-class="sidebar-left-collapsed" data-target="html" data-fire-event="sidebar-left-toggle">
                    <i className="fa fa-bars" aria-label="Toggle sidebar"></i>
                </div>
            </div>

            <div className="nano">
                <div className="nano-content">
                    <nav id="menu" className="nav-main" role="navigation">
                        <ul className="nav nav-main">
                            <li>
                                <Link className="nav-link" to="/">
                                    <i className="fa fa-home" aria-hidden="true"></i>
                                    <span>Dashboard</span>
                              </Link>
                            </li>
                            <li>
                                <Link className="nav-link" to="/patients/list">
                                    <i className="fa fa-address-card" aria-hidden="true"></i>
                                    <span>Patients</span>
                                </Link>
                            </li>
                            <li>
                                <Link className="nav-link" to="/setting">
                                    <i className="fa fa-cog" aria-hidden="true"></i>
                                    <span>Setting</span>
                                </Link>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </aside>
    )
  }
}

export default Menu;
